import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  tone?: 'dark' | 'light';
  align?: 'left' | 'center';
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  tone = 'dark',
  align = 'center'
}: SectionHeadingProps) {
  const centered = align === 'center';
  return <div className={`${centered ? 'mx-auto text-center' : ''} max-w-3xl`} data-id="element-12" data-mp="3k0ygy8sfb398">
      {eyebrow && <p className={`mb-2 text-xs font-bold uppercase tracking-[0.2em] ${tone === 'dark' ? 'text-lime' : 'text-pumpkin-dark'}`} data-id="element-13" data-mp="blogf546m63k">
          {eyebrow}
        </p>}
      <h2 className={`font-display text-[32px] font-extrabold leading-[1.05] tracking-tight sm:text-5xl ${tone === 'dark' ? 'text-cream' : 'text-ink'}`} data-id="element-14" data-mp="1u0ufjqe9h9h">
        {title}
      </h2>
      {subtitle && <p className={`mt-3 text-base leading-relaxed sm:text-lg ${tone === 'dark' ? 'text-muted' : 'text-ink/70'}`} data-id="element-15" data-mp="z9y1u5xhgru6">{subtitle}</p>}
    </div>;
}